import React from 'react'

const Error = function (){
    return <div className='centered-box'><div className='error-box'><h1>There is no such page on this website. We are really sorry (error 404)</h1></div></div>
}
export default Error